/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

const form = {
    formId: "new-doctor-form",
    formField: {
        name: {
            name: "name",
            label: "Nombre",
            type: "text",
            errorMsg: "El nombre es obligatorio.",
        },
        specialty: {
            name: "specialty",
            label: "Especialidad",
            type: "text"
        },
        badge: {
            name: "badge",
            label: "Cédula",
            type: "text"
        },
        email: {
            name: "email",
            label: "Correo Electrónico",
            type: "text",
            errorMsg: "El correo elecrónico es obligatorio.",
            invalidMsg: "El correo electrónico es inválido.",
        },
        phone: {
            name: "phone",
            label: "Teléfono",
            type: "text"
        },
        address: {
            name: "address",
            label: "Dirección",
            type: "text",
            errorMsg: "La dirección es obligatoria.",
        },
        business_name: {
            name: "business_name",
            label: "Lugar de Trabajo",
            type: "text",
            errorMsg: "El lugar de trabajo es obligatorio.",
        },
        business_email: {
            name: "business_email",
            label: "Correo Comercial",
            type: "text",
            errorMsg: "El correo comercial es obligatorio.",
            invalidMsg: "El correo electrónico es inválido.",
        },
        business_phone: {
            name: "business_phone",
            label: "Teléfono Comercial",
            type: "text",
            errorMsg: "El teléfono comercial es obligatorio.",
        },
        business_address: {
            name: "business_address",
            label: "Dirección Comercial",
            type: "text",
            errorMsg: "La dirección comercial es obligatoria.",
        },
        bank: {
            name: "bank",
            label: "Banco",
            type: "text",
            errorMsg: "El banco es obligatorio.",
        },
        bank_account: {
            name: "bank_account",
            label: "Clabe Interbancaria",
            type: "text",
            errorMsg: "La Clabe es obligatoria.",
        },
        short_description: {
            name: "short_description",
            label: "Descripción Corta",
            type: "text",
            multiline: true,
            rows: 2,
            errorMsg: "La descripción es obligatoria.",
        },
        password: {
            name: "password",
            label: "Contraseña",
            type: "password",
            errorMsg: "La contraseña es obligatoria.",
            invalidMsg: "La contraseña debe contener al menos 8 caracteres",
        },
        password_confirmation: {
            name: "password_confirmation",
            label: "Confirmar contraseña",
            type: "password",
            errorMsg: "La confirmación es obligatoria.",
            invalidMsg: "Las contraseñas no coinciden.",
        },
        rfc: {
            name: "rfc",
            label: "RFC",
            type: "text",
            errorMsg: "El RFC es obligatorio.",
        },
        account_name: {
            name: "account_name",
            label: "Nombre de Titular",
            type: "text",
            errorMsg: "El nombre el titular es obligatorio.",
        },
        account_email: {
            name: "account_email",
            label: "Correo de Titular",
            type: "text",
            errorMsg: "El correo de titular es obligatorio.",
            invalidMsg: "El correo electrónico es inválido.",
        }
    },
};

export default form;
